module.exports = __webpack_public_path__ + "media/images/athletes/499-cc7ca00955cc0f884c55b23559075b7a.png";